var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({attrs:{"icon":"","color":_vm.color},on:{"click":[function($event){$event.stopPropagation();},function($event){return _vm.$emit('click')}]}},'v-btn',_vm.$attrs,false),[_c('v-icon',[_vm._v("mdi-delete")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }